<template>
  <div>
    <div id="core" data-guide="editor-canvas"></div>
    <div v-if="templateError" class="material_loading" role="alert">
      <div class="material_loading_card">
        <div class="material_loading_title">模板未能完整加载</div>
        <div class="material_loading_text">{{ templateError }}</div>
        <van-button size="small" type="primary" @click="loadTemplateArtwork(templateExpandId)">重新加载</van-button>
      </div>
    </div>
    <div v-if="activeLoading.show" class="material_loading">
      <div class="material_loading_card">
        <div class="material_loading_title">{{ activeLoading.title }}</div>
        <div class="material_loading_text">{{ activeLoading.text }}</div>
        <div class="material_loading_progress">
          <div :style="{ width: activeLoading.progress + '%' }"></div>
        </div>
        <div class="material_loading_percent">{{ activeLoading.progress }}%</div>
      </div>
    </div>
    <van-dialog
      v-model="nameTip"
      title="作品名称"
      @confirm="save"
      :close-on-click-overlay="true"
    >
      <van-field v-model="name" label="" placeholder="请填写作品名称" />
    </van-dialog>
  </div>
</template>

<script>
import { Editor } from "../../../../3D-editor/index";
import { base64ToFile, uploadImage } from "@/plugins/utils.js";
import { defaultArtwork } from "@/mock/defaultArtwork";
const { buildUseMaterials } = require("@/utils/artworkMaterials");
const { scoreArtwork } = require("@/utils/artworkScore");
import { Toast } from "vant";
import wx from "weixin-js-sdk";
let editor;
export default {
  data() {
    return {
      id: null,
      name: null,
      ossData: null,
      describe: null,
      nameTip: false,

      autoSaveTimer: null,
      materialLoading: {
        show: false,
        progress: 0,
        title: "",
        text: "",
      },
      materialLoadingTimer: null,
      materialLoadingDelayTimer: null,
      templateLoading: {
        show: false,
        progress: 0,
        title: "模板正在加载",
        text: "正在获取模板数据，请稍候。",
      },
      editorType: "free3d",
      templateExpandId: "",
      templateLoadVersion: 0,
      templateError: "",
    };
  },
  computed: {
    activeLoading() {
      return this.templateLoading.show ? this.templateLoading : this.materialLoading;
    },
  },
  watch: {
    "$route.query.productExpandId"(value) {
      const nextTemplateId = this.normalizeTemplateExpandId(value);
      if (!nextTemplateId) {
        if (this.templateExpandId) {
          this.templateLoadVersion += 1;
          this.handleTemplateSessionExit();
          this.resetEditorWorkspace();
          this.templateExpandId = "";
          this.templateError = "";
          this.clearTemplateLoading();
          this.$nextTick(() => this.autoSaveCG());
        }
        return;
      }
      if (nextTemplateId === this.templateExpandId) {
        return;
      }
      this.loadTemplateArtwork(nextTemplateId);
    },
  },
  destroyed() {
    this.templateLoadVersion += 1;
    this.stopAutoSave();
    this.clearTemplateDraftCache();
    window.removeEventListener("pagehide", this.handleTemplateSessionExit);
    window.removeEventListener("beforeunload", this.handleTemplateSessionExit);
    this.clearMaterialLoading();
    this.clearTemplateLoading();
  },
  async mounted() {
    this.editorType = this.getEditorType();
    this.templateExpandId = this.normalizeTemplateExpandId(this.$route.query.productExpandId);
    this.templateLoadQueue = Promise.resolve();
    editor = new Editor({
      dom: "core",
      plat: "mobile",
      readOnly: this.$store.state.routeParams.mode !== "edit",
      editorType: this.editorType,
    });
    this.getOSSKey();
    //添加bus线事件
    this.addBusEvent();
    //添加编辑器事件
    this.addEditorEvent();
    window.addEventListener("pagehide", this.handleTemplateSessionExit);
    window.addEventListener("beforeunload", this.handleTemplateSessionExit);
    if (this.templateExpandId) {
      await this.loadTemplateArtwork(this.templateExpandId);
    } else if (this.$store.state.routeParams.productId) {
      this.id = this.$store.state.routeParams.productId;
      this.getData(this.id);
    }

    this.$nextTick(() => {
      const { productId, mode } = this.$route.query;
      const draftKey = this.getDraftKey();
      if ((mode === "edit" || !mode) && !productId && !this.templateExpandId) {
        let dataJson = localStorage.getItem(draftKey);
        if (dataJson) {
          dataJson = JSON.parse(dataJson);
          if (this.isTestArtworkData(dataJson)) {
            localStorage.removeItem(draftKey);
          } else {
            this.loadArtwork({
              dataJson,
            });
          }
        }

        this.autoSaveCG();
      }
    });
  },
  methods: {
    normalizeTemplateExpandId(value) {
      return value === undefined || value === null || value === "" ? "" : String(value);
    },
    isScannedTemplateSession(productExpandId = this.templateExpandId) {
      const routeTemplateId = this.normalizeTemplateExpandId(this.$route.query.productExpandId);
      const routeShareCode = this.normalizeTemplateExpandId(this.$route.query.templateShareCode);
      return !!(
        routeShareCode &&
        routeTemplateId &&
        routeTemplateId === this.normalizeTemplateExpandId(productExpandId)
      );
    },
    applyScannedTemplateDefaults(productExpandId) {
      if (!this.isScannedTemplateSession(productExpandId)) {
        return;
      }
      editor.setTouchHelper(false);
      this.setEditorZoom(0.75);
      this.$bus.$emit("layer-panel-collapse");
    },
    getDraftKeys() {
      const type = this.$route.query.type || "practice";
      return [`${type}JsonData`, `${type}StudioJsonData`];
    },
    getDraftKey() {
      const type = this.$route.query.type || "practice";
      return this.editorType === "studio" ? `${type}StudioJsonData` : `${type}JsonData`;
    },
    stopAutoSave() {
      if (this.autoSaveTimer) {
        clearInterval(this.autoSaveTimer);
        this.autoSaveTimer = null;
      }
    },
    clearTemplateDraftCache() {
      if (!this.templateExpandId) {
        return;
      }
      this.getDraftKeys().forEach(key => localStorage.removeItem(key));
    },
    handleTemplateSessionExit() {
      if (!this.templateExpandId) {
        return;
      }
      this.stopAutoSave();
      this.clearTemplateDraftCache();
    },
    resetEditorWorkspace() {
      this.id = "";
      this.name = null;
      this.describe = null;
      this.nameTip = false;
      if (!editor) {
        return;
      }
      editor.clear("all");
      editor.setBackground("");
      if (editor.clearLayerSelection) {
        editor.clearLayerSelection();
      }
      if (editor.commandManager) {
        editor.commandManager.commands = [];
        editor.commandManager.redoCommands = [];
      }
      this.$bus.$emit("step-change", {
        revoke: 0,
        redo: 0,
      });
    },
    loadTemplateArtwork(productExpandId) {
      const normalizedId = this.normalizeTemplateExpandId(productExpandId);
      if (!normalizedId) {
        return Promise.resolve();
      }
      this.templateExpandId = normalizedId;
      this.templateError = "";
      this.templateLoadVersion += 1;
      const loadVersion = this.templateLoadVersion;
      const progressive = this.isScannedTemplateSession(normalizedId);
      this.stopAutoSave();
      this.clearTemplateDraftCache();
      if (progressive) {
        this.startTemplateLoading();
      }

      const previousLoad = this.templateLoadQueue || Promise.resolve();
      this.templateLoadQueue = previousLoad
        .catch(() => {})
        .then(async () => {
          if (loadVersion !== this.templateLoadVersion) {
            return;
          }
          this.resetEditorWorkspace();
          await this.getData("", normalizedId, {
            progressive,
            shouldCancel: () => loadVersion !== this.templateLoadVersion,
            onProgress: payload => {
              if (loadVersion === this.templateLoadVersion) {
                this.updateTemplateLoading(payload);
              }
            },
          });
          if (loadVersion === this.templateLoadVersion) {
            this.applyScannedTemplateDefaults(normalizedId);
            this.clearTemplateDraftCache();
          }
        })
        .catch((error) => {
          if (loadVersion === this.templateLoadVersion) {
            this.resetEditorWorkspace();
            this.templateError = error && error.message ? error.message : "模板加载失败，请检查网络后重试";
          }
        })
        .then(() => {
          if (loadVersion === this.templateLoadVersion) {
            this.clearTemplateLoading();
          }
        });
      return this.templateLoadQueue;
    },
    getEditorType() {
      return this.$route.path === "/studio" || this.$route.query.editorType === "studio" ? "studio" : "free3d";
    },
    hasArtworkContent(dataJson) {
      const objects = (dataJson && dataJson.objects) || {};
      return !!(
        (objects.flowers && objects.flowers.length) ||
        objects.container ||
        (objects.containers && objects.containers.length)
      );
    },
    loadArtwork(artwork, loadOptions = {}) {
      if (artwork.name) {
        this.name = artwork.name;
      }
      this.describe = artwork.describe || null;
      if (artwork.dataJson && editor.resolveArtworkEditorType) {
        this.editorType = editor.resolveArtworkEditorType(artwork.dataJson);
        this.$bus.$emit("editor-type-change", this.editorType);
      }
      if (artwork.dataJson && artwork.dataJson.params && artwork.dataJson.params.studio) {
        this.$bus.$emit("studio-state-change", artwork.dataJson.params.studio);
      }
      this.$bus.$emit("setDefaultAngle", artwork.dataJson.angle);
      return editor.load(artwork.dataJson, loadOptions);
    },
    isTestArtworkData(dataJson) {
      const defaultData = defaultArtwork.dataJson;
      const flowers = (dataJson.objects && dataJson.objects.flowers) || [];
      const defaultFlowers = defaultData.objects.flowers;
      const container = dataJson.objects && dataJson.objects.container;
      const defaultContainer = defaultData.objects.container;
      const defaultResourceIds = defaultFlowers.map(flower => flower.resourceId);
      const testResourceCount = flowers.filter(flower => defaultResourceIds.includes(flower.resourceId)).length;
      return (
        container &&
        defaultContainer &&
        container.resourceId === defaultContainer.resourceId &&
        (
          (
            flowers.length === defaultFlowers.length &&
            flowers.every((flower, index) => flower.resourceId === defaultFlowers[index].resourceId)
          ) ||
          (flowers.length >= 15 && testResourceCount / flowers.length > 0.85)
        )
      );
    },
    autoSaveCG() {
      this.stopAutoSave();
      if (this.templateExpandId) {
        return;
      }

      this.autoSaveTimer = setInterval(async () => {
        if (this.templateExpandId) {
          return;
        }
        let saveData = await editor.save();

        localStorage.setItem(this.getDraftKey(), JSON.stringify(saveData.jsonData));
      }, 5000);
    },
    getOSSKey() {
      return new Promise((resolve) => {
        this.$ajax
          .post("/user/oss/getKey?pathName=common")
          .then(async (res) => {
            this.ossData = res.data;
            resolve(res.data);
          });
      });
    },
    getData(id, productExpandId = this.$route.query.productExpandId, loadOptions = {}) {
      let url = "/product/getById";
      let params = {
        id,
        type: 1,
      };
      if (productExpandId) {
        url = "/product/expand/getById";
        params = {
          productExpandId,
          type: 1,
        };
      }

      return this.$ajax
        .get(url, {
          params,
        })
        .then((res) => {
          return this.loadArtwork(
            {
              name: productExpandId ? "" : res.data.name,
              describe: res.data.describe,
              dataJson: JSON.parse(res.data.dataJson),
            },
            loadOptions
          );
        });
    },
    addBusEvent() {
      this.$bus.$on("setBackground", (val) => {
        editor.setBackground(val);
      });

      this.$bus.$on("setStudioPreset", (val) => {
        editor.setStudioPreset(val);
      });

      this.$bus.$on("setStudioBackground", (val) => {
        editor.setStudioBackground(val);
      });

      this.$bus.$on("setStudioBackgroundAdjust", (val) => {
        editor.setStudioBackgroundAdjust(val);
      });

      this.$bus.$on("set-editor-type", (val) => {
        this.setEditorType(val);
      });

      this.$bus.$on("switch-editor-type", (val) => {
        this.switchEditorType(val);
      });

      this.$bus.$on("select-container", (id) => {
        editor.selectContainerById(id);
      });

      this.$bus.$on("setContainerPosition", (val) => {
        editor.setContainerPosition(val);
      });

      this.$bus.$on("setContainerRotation", (val) => {
        editor.setContainerRotation(val);
      });

      this.$bus.$on("setContainerShadow", (val) => {
        editor.setContainerShadow(val);
      });

      this.$bus.$on("setStudioGroupRotation", (val) => {
        editor.setStudioGroupRotation(val);
      });

      this.$bus.$on("set-zoom", (val) => {
        this.setEditorZoom(val);
      });
      //添加
      this.$bus.$on("addItem", async (payload) => {
        const isContainer = payload && payload.materialClassifyId1 === 2;
        const loadingTitle = isContainer ? "容器正在加载" : "花材正在加载";
        const loadingText = isContainer ? "正在把容器放入画布，请稍候。" : "花材正在加载进画布，请稍候。";
        const successText = isContainer ? "已将容器放入画布" : "已将花材放入画布";
        this.startMaterialLoading(loadingTitle, loadingText);
        try {
          const addedId = await editor.addItem(payload);
          if (!addedId) {
            this.clearMaterialLoading();
            return;
          }
          this.finishMaterialLoading();
          Toast({
            message: successText,
            duration: 2600,
            className: "material-success-toast",
          });
        } catch (error) {
          this.clearMaterialLoading();
        }
      });

      //图层
      this.$bus.$on("layer-show", (id) => {
        editor.layerShow(id);
      });
      this.$bus.$on("layer-select", (id) => {
        if (editor.selectLayerById) {
          editor.selectLayerById(id);
        } else {
          editor.selectFlowerById(id);
        }
      });
      this.$bus.$on("layer-clear-selection", () => {
        if (editor.clearLayerSelection) {
          editor.clearLayerSelection();
        } else {
          editor.clearFlowerSelection();
        }
      });
      this.$bus.$on("layer-toggle-visible", (id) => {
        if (editor.toggleLayerVisible) {
          editor.toggleLayerVisible(id);
        } else {
          editor.toggleFlowerVisible(id);
        }
      });
      this.$bus.$on("layer-toggle-lock", (id) => {
        editor.toggleFlowerLock(id);
      });
      this.$bus.$on("layer-set-all-visible", (visible) => {
        editor.setAllFlowerVisible(visible);
      });
      this.$bus.$on("layer-set-all-lock", (locked) => {
        editor.setAllFlowerLock(locked);
      });
      this.$bus.$on("setStemVisible", (data) => {
        editor.setFlowerStemVisible(data);
      });
      this.$bus.$on("setStemRadius", (data) => {
        editor.setFlowerStemRadius(data);
      });
      //弯曲
      this.$bus.$on("setBindingY", (data) => {
        if (data.isAll) {
          editor.setAllBindingY(data);
        } else {
          editor.setBindingY(data);
        }
      });
      //起始位置
      this.$bus.$on("setStartPosition", (data) => {
        editor.setStartPosition(data);
      });

      //大小
      this.$bus.$on("setSize", (data) => {
        editor.setSize(data);
      });
      this.$bus.$on("setContainerLight", (val) => {
        editor.setContainerLight(val);
      });
      this.$bus.$on("score-artwork", () => {
        this.$bus.$emit("artwork-score-result", scoreArtwork(editor.getArtworkData()));
      });
      //旋转
      this.$bus.$on("rotate", (p) => {
        let r = editor.rotate(p);
        this.$bus.$emit("rotate-result", r);
      });
      //移除
      this.$bus.$on("remove", (id) => {
        editor.remove(id);
      });

      //清除
      this.$bus.$on("clear", (type) => {
        editor.clear(type);
      });

      //复制
      this.$bus.$on("copy", (id) => {
        editor.copy(id);
      });

      //替换
      this.$bus.$on("replace", (params) => {
        editor.replace(params);
      });

      //触摸点
      this.$bus.$on("setTouchHelper", (val) => {
        editor.setTouchHelper(val);
      });

      //插法
      this.$bus.$on("setBindingType", (type) => {
        editor.setBindingType(type);
      });

      //画布锁定
      this.$bus.$on("canvasLock", (val) => {
        editor.canvasLock(val);
      });

      //角度
      this.$bus.$on("setAngle", (val) => {
        editor.setAngle(val);
      });

      //后退
      this.$bus.$on("revoke", () => {
        editor.revoke();
      });

      //前进
      this.$bus.$on("redo", () => {
        editor.redo();
      });

      //插法
      this.$bus.$on("setContainerSize", (val) => {
        editor.setContainerSize(val);
      });

      //控制剑山
      this.$bus.$on("showJsContainer", (val) => {
        editor.showJsContainer(val);
      });

      //保存
      this.$bus.$on("save", (type, form, isDesign) => {
        if (type === "practice") {
          this.save(isDesign || '');
        } else {
          this.workSave(form);
        }
      });

      //渲染
      this.$bus.$on("renderRealScene", () => {
        editor.renderRealScene();
      });
    },
    addEditorEvent() {
      editor.addEventListener("contain-change", (command) => {
        if (command && command.constructor && command.constructor.name === "AddItemCommand") {
          return;
        }
        this.$bus.$emit("editor-contain-change", command);
        Toast("操作成功");
      });

      editor.addEventListener("flower-choose", (val) => {
        this.$bus.$emit("flower-choose", val);
      });

      editor.addEventListener("layer-change", (val) => {
        this.$bus.$emit("layer-change", val);
      });

      editor.addEventListener("camera-change", (val) => {
        this.$bus.$emit("camera-change", val);
      });

      editor.addEventListener("step", (val) => {
        this.$bus.$emit("step-change", val);
      });

      editor.addEventListener("container-add", (val) => {
        this.$bus.$emit("container-add", val);
      });

      editor.addEventListener("studio-containers-change", (val) => {
        this.$bus.$emit("studio-containers-change", val);
      });

      editor.addEventListener("jianshan-reset", (val) => {
        this.$bus.$emit("jianshan-reset", val);
      });

      editor.addEventListener("touch-helper-change", (val) => {
        this.$bus.$emit("touch-helper-change", val);
      });

      editor.addEventListener("selection-helper-position", (val) => {
        this.$bus.$emit("selection-helper-position", val);
      });

      editor.addEventListener("jianshan-visible-change", (val) => {
        this.$bus.$emit("jianshan-visible-change", val);
      });

      editor.addEventListener("flower-move", (val) => {
        this.$bus.$emit("flower-move", val);
      });

      editor.addEventListener("error", (val) => {
        Toast(val.msg);
      });

      editor.syncLayerState();
    },
    setEditorZoom(value) {
      const zoom = Number(value);
      if (!Number.isFinite(zoom) || zoom <= 0) {
        return;
      }
      editor.setZoom(zoom);
      this.$bus.$emit("zoom-change", zoom);
    },
    startTemplateLoading() {
      this.templateLoading.show = true;
      this.templateLoading.progress = 3;
      this.templateLoading.title = "模板正在加载";
      this.templateLoading.text = "正在获取模板数据，请稍候。";
    },
    updateTemplateLoading(payload = {}) {
      const progress = Number(payload.percent);
      if (Number.isFinite(progress)) {
        this.templateLoading.progress = Math.max(
          this.templateLoading.progress,
          Math.min(100, Math.round(progress))
        );
      }
      if (payload.phase === "complete") {
        this.templateLoading.text = "模板加载完成，正在准备编辑器。";
        return;
      }
      if (payload.phase === "prepare") {
        this.templateLoading.text = "正在准备模板素材，请稍候。";
        return;
      }
      const current = Number(payload.current) || 0;
      const total = Number(payload.total) || 0;
      const itemLabel = payload.itemType === "container" ? "容器" : "花材";
      this.templateLoading.text = total
        ? `正在加载${itemLabel} ${current}/${total}`
        : "正在准备模板素材，请稍候。";
    },
    clearTemplateLoading() {
      this.templateLoading.show = false;
      this.templateLoading.progress = 0;
      this.templateLoading.text = "正在获取模板数据，请稍候。";
    },
    startMaterialLoading(title, text) {
      this.clearMaterialLoading();
      this.materialLoading.progress = 8;
      this.materialLoading.title = title;
      this.materialLoading.text = text;
      this.materialLoadingDelayTimer = setTimeout(() => {
        this.materialLoading.show = true;
      }, 260);
      this.materialLoadingTimer = setInterval(() => {
        if (this.materialLoading.progress < 88) {
          this.materialLoading.progress += this.materialLoading.progress < 45 ? 7 : 4;
        }
      }, 220);
    },
    finishMaterialLoading() {
      clearTimeout(this.materialLoadingDelayTimer);
      clearInterval(this.materialLoadingTimer);
      this.materialLoadingDelayTimer = null;
      this.materialLoadingTimer = null;
      if (this.materialLoading.show) {
        this.materialLoading.progress = 100;
        setTimeout(() => {
          this.materialLoading.show = false;
        }, 280);
      }
    },
    clearMaterialLoading() {
      clearTimeout(this.materialLoadingDelayTimer);
      clearInterval(this.materialLoadingTimer);
      this.materialLoadingDelayTimer = null;
      this.materialLoadingTimer = null;
      this.materialLoading.show = false;
      this.materialLoading.progress = 0;
    },
    setEditorType(type) {
      this.editorType = type === "studio" ? "studio" : "free3d";
      editor.setEditorType(this.editorType);
      this.$bus.$emit("editor-type-change", this.editorType);
    },
    async saveCurrentDraft() {
      const dataJson = editor.getArtworkData();
      if (this.hasArtworkContent(dataJson)) {
        localStorage.setItem(this.getDraftKey(), JSON.stringify(dataJson));
      } else {
        localStorage.removeItem(this.getDraftKey());
      }
    },
    async switchEditorType(type) {
      const nextType = type === "studio" ? "studio" : "free3d";
      if (nextType === this.editorType) {
        return;
      }
      await this.saveCurrentDraft();
      editor.clear("all");
      editor.setBackground("");
      this.editorType = nextType;
      editor.setEditorType(nextType);
      this.$bus.$emit("editor-type-change", nextType);
      const draftData = localStorage.getItem(this.getDraftKey());
      if (draftData) {
        this.loadArtwork({
          dataJson: JSON.parse(draftData),
        });
      }
    },
    async workSave(form) {
      let saveData = await editor.save({
        angles: [
          {
            x: 90,
            y: 0,
          },
          {
            x: 90,
            y: 90,
          },
          {
            x: 90,
            y: 180,
          },
          {
            x: 90,
            y: 270,
          },
          {
            x: 0,
            y: 0,
          },
        ],
      });

      const useMaterials = buildUseMaterials(saveData.jsonData.objects);

      let uploadPromises = [];

      await this.getOSSKey();

      for (let base64 of saveData.base64) {
        uploadPromises.push(
          uploadImage(
            {
              file: base64ToFile(base64, new Date().getTime() + ".png"),
            },
            this.ossData
          )
        );
      }
      Promise.all(uploadPromises).then((fileAddrs) => {
        this.$ajax
          .post("/product/save", {
            id: null,
            dataJson: JSON.stringify(saveData.jsonData),
            source: 3,
            name: form.name,
            coverImage: fileAddrs[1].addr,
            useMaterials,
            describe: null,
          })
          .then((res) => {
            const answerTime = parseInt(
              (new Date().getTime() - sessionStorage.getItem("startTime")) /
                (1000 * 60)
            );
            const type = this.$store.state.routeParams.type;
            let params = {
              id: this.$store.state.routeParams.id,
              productId: res.data,
              answerTime: answerTime || 1,
            };
            params[type + "Images"] = fileAddrs.map((item) => {
              return item.addr;
            });
            params[type + "Desc"] = form.desc;
            this.$ajax.post(`/${type}/student/submit`, params).then((res) => {
              localStorage.removeItem(this.getDraftKey());

              Toast("提交成功");
              editor.clear();
              setTimeout(() => {
                wx.miniProgram.navigateBack({});
              }, 500);
            });
          });
      });
    },
    async save(design) {
      this.nameTip = false;
      let saveData = await editor.save();
      if (
        !saveData.jsonData.objects.flowers.length &&
        !saveData.jsonData.objects.container &&
        !(saveData.jsonData.objects.containers && saveData.jsonData.objects.containers.length)
      ) {
        Toast("请先编辑后再保存");
        return;
      }
      if (!this.id && !this.name) {
        Toast("请输入作品名称");
        this.nameTip = true;
        return;
      }

      const useMaterials = buildUseMaterials(saveData.jsonData.objects);
      let file = base64ToFile(saveData.base64, new Date().getTime() + ".png");

      await this.getOSSKey();

      uploadImage(
        {
          file,
        },
        this.ossData
      ).then((res) => {
        this.$ajax
          .post("/product/save", {
            id: this.id,
            dataJson: JSON.stringify(saveData.jsonData),
            source: 1,
            name: this.name,
            coverImage: res.addr,
            useMaterials,
            describe: this.describe,
          })
          .then((res) => {
            localStorage.removeItem(this.getDraftKey());

            Toast("保存成功");
            this.id = null;
            this.name = null;
            editor.clear();
            if (design) {
              this.$router.push({
                  path: "/design"
              })
            }
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#core {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: #fff;
  --studio-bg-x: 0px;
  --studio-bg-y: 0px;
  --studio-bg-scale: 1;
  --studio-bg-brightness: 1;
  --studio-bg-contrast: 1;

  ::v-deep .studio_background_layer {
    position: absolute;
    inset: 0;
    z-index: 0;
    display: none;
    pointer-events: none;
    transform: translate(var(--studio-bg-x), var(--studio-bg-y)) scale(var(--studio-bg-scale));
    transform-origin: center center;
    filter: brightness(var(--studio-bg-brightness)) contrast(var(--studio-bg-contrast));
    will-change: transform, filter;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 48%;
      height: 1px;
      background: rgba(152, 134, 111, 0.18);
      pointer-events: none;
    }

    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 10%;
      width: rem(560);
      height: rem(138);
      transform: translateX(-50%);
      background: radial-gradient(ellipse, rgba(84, 69, 52, 0.18), rgba(84, 69, 52, 0) 68%);
      pointer-events: none;
    }
  }

  &.studio-background ::v-deep .studio_background_layer {
    display: block;
    background:
      radial-gradient(circle at 50% 30%, rgba(255, 255, 255, 0.92) 0, rgba(255, 255, 255, 0) 34%),
      linear-gradient(180deg, #f6f4ef 0%, #f8f7f3 48%, #e5ddd0 48%, #d8cdbc 100%);
  }

  &.studio-background.studio-preset-white ::v-deep .studio_background_layer {
    background:
      radial-gradient(circle at 50% 30%, rgba(255, 255, 255, 0.95) 0, rgba(255, 255, 255, 0) 34%),
      linear-gradient(180deg, #ffffff 0%, #fbfcfb 48%, #eef0ed 48%, #e4e7e2 100%);
  }

  &.studio-background.studio-preset-gray ::v-deep .studio_background_layer {
    background:
      radial-gradient(circle at 50% 30%, rgba(255, 255, 255, 0.72) 0, rgba(255, 255, 255, 0) 34%),
      linear-gradient(180deg, #f2f4f5 0%, #eef1f3 48%, #d7dde2 48%, #c8d0d7 100%);
  }

  &.studio-background.studio-preset-dark ::v-deep .studio_background_layer {
    background:
      radial-gradient(circle at 50% 28%, rgba(255, 255, 255, 0.16) 0, rgba(255, 255, 255, 0) 36%),
      linear-gradient(180deg, #3e4247 0%, #2d3035 48%, #222427 48%, #15171a 100%);
  }

  &.studio-background.studio-preset-white ::v-deep .studio_background_layer::after {
    background: radial-gradient(ellipse, rgba(74, 80, 72, 0.12), rgba(74, 80, 72, 0) 68%);
  }

  &.studio-background.studio-preset-gray ::v-deep .studio_background_layer::after {
    background: radial-gradient(ellipse, rgba(50, 60, 68, 0.16), rgba(50, 60, 68, 0) 68%);
  }

  &.studio-background.studio-preset-dark ::v-deep .studio_background_layer::before {
    background: rgba(255, 255, 255, 0.08);
  }

  &.studio-background.studio-preset-dark ::v-deep .studio_background_layer::after {
    background: radial-gradient(ellipse, rgba(0, 0, 0, 0.32), rgba(0, 0, 0, 0) 68%);
  }

  &.studio-background.studio-custom-background ::v-deep .studio_background_layer::before,
  &.studio-background.studio-custom-background ::v-deep .studio_background_layer::after {
    display: none;
  }

  ::v-deep canvas {
    position: relative;
    z-index: 1;
  }
}

.material_loading {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 120;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(32, 39, 30, 0.18);
}

.material_loading_card {
  width: rem(520);
  padding: rem(34) rem(32) rem(28);
  border-radius: rem(22);
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 rem(16) rem(40) rgba(30, 42, 24, 0.22);
  box-sizing: border-box;
}

.material_loading_title {
  color: #243026;
  font-size: rem(32);
  font-weight: bold;
  text-align: center;
}

.material_loading_text {
  margin-top: rem(12);
  color: #697264;
  font-size: rem(24);
  line-height: rem(34);
  text-align: center;
}

.material_loading_progress {
  height: rem(16);
  margin-top: rem(26);
  border-radius: rem(8);
  overflow: hidden;
  background: #e7ecdf;

  > div {
    height: 100%;
    border-radius: inherit;
    background: linear-gradient(90deg, #7faa27, #f2b452);
    transition: width 0.18s ease;
  }
}

.material_loading_percent {
  margin-top: rem(12);
  color: #6e9f21;
  font-size: rem(24);
  font-weight: bold;
  text-align: center;
}
</style>
<style lang="scss">
.material-success-toast {
  min-width: rem(320);
  padding: rem(24) rem(30);
  border-radius: rem(18);
  background: rgba(64, 91, 31, 0.96);
  box-shadow: 0 rem(12) rem(32) rgba(42, 58, 26, 0.28);

  .van-toast__text {
    font-size: rem(28);
    line-height: rem(38);
    font-weight: bold;
  }
}
</style>
